// extracted by mini-css-extract-plugin
module.exports = {"bundle-banner-container":"HouseBundleBanner_bundle-banner-container__cIPlV","description":"HouseBundleBanner_description__szTES","icon":"HouseBundleBanner_icon__o1XFT"};